import {
  Card,
  CardContent,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { AccountType } from 'generated/types';

const messages = defineMessages({
  accountType: {
    id: 'account.type',
    defaultMessage: 'Account Type',
  },
  org: {
    id: 'account.type.organization',
    defaultMessage: 'Organization',
  },
  indie: {
    id: 'account.type.individual',
    defaultMessage: 'Individual',
  },
});

interface SelectAccountTypeProps {
  /** Account's type */
  accountType: AccountType;
  /** Callback fired when the selected account type changes */
  onChange: (accountType: AccountType) => void;
}

/** For selecting the type of a new account */
function SelectAccountType({ accountType, onChange }: SelectAccountTypeProps) {
  const { formatMessage } = useIntl();

  return (
    <Card sx={{ width: 'fit-content' }}>
      <CardContent>
        <FormControl>
          <FormLabel id="account-type-input-label">
            {formatMessage(messages.accountType)}
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="account-type-input-label"
            onChange={(_event, value) => onChange(value as AccountType)}
            value={accountType}
          >
            <FormControlLabel
              value={AccountType.individual}
              control={<Radio />}
              label={formatMessage(messages.indie)}
            />
            <FormControlLabel
              value={AccountType.organization}
              control={<Radio />}
              label={formatMessage(messages.org)}
            />
          </RadioGroup>
        </FormControl>
      </CardContent>
    </Card>
  );
}

export { SelectAccountType };
